import { firebaseReducer } from 'react-redux-firebase';
import { combineReducers } from 'redux';
import { firestoreReducer } from 'redux-firestore';
import { reducer as FormReducer } from 'redux-form';

import modalReducer from '../app/common/modals/modalReducer';
import complaintReducer from '../app/pages/Dashboard/Complaint/complaintReducer';
import asyncReducer from '../app/common/async/asyncReducer';

import { reducer as ToastrReducer } from 'react-redux-toastr';
import toggleReducer from '../app/layout/MainSidebar/sidebarReducer';

const rootReducer = combineReducers({
	complaints: complaintReducer,
	form: FormReducer,
	modals: modalReducer,
	firebase: firebaseReducer,
	firestore: firestoreReducer,
	async: asyncReducer,
	toastr: ToastrReducer,
	toggleStatus: toggleReducer
});

export default rootReducer;
